export enum EskerOrderIssueType {
    SOLD_TO_ACCOUNT_NUMBER_INCORRECT = 'Sold-to Account Number Incorrect',
    SHIP_TO_ACCOUNT_NUMBER_INCORRECT = 'Ship-to Account Number Incorrect',
    BILL_TO_ACCOUNT_NUMBER_INCORRECT = 'Bill-to Account Number Incorrect',
    WRONG_SMN_RECEIVED = 'Wrong SMN Received',
    WRONG_QTY_RECEIVED = 'Wrong Qty Received'
}
